// React Imports
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Redux Imports
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { ReimbursementTxnMultiWaitingApproval } from "../../../redux/features/reimbursementTransaction";

// Component Imports
import { toast } from "react-toastify";
import Loader from "../../Loader/Index";
import SecondaryButton from "../../_utils/CommonButtons/SecondaryButton";
import CommonToast from "../../_utils/CommonToast";
import ApprovalTopNavComponent from "../../_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import ReimbursementDeclinePopup from "../../_utils/TransactionCommonComponents/CommonDeclinePopups/ReimbursementDeclinePopup";
import UniversalRefreshToast from "../../_utils/UniversalRefreshToast";
import ReimbursementTxnDetailsPopup from "../ReimbursementTxnDetailsPopup/index.jsx";

// Utils Imports
import ICONS from "../../../assets/Icons/index.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";

const ReimbursementTxnMultiApprovalDetail = () => {
  const refreshingToastId = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [refreshId, setRefreshId] = useState("");
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(null);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [deniedId, SetdeniedId] = useState();

  const services = useSelector((state) => state.refreshToken.services);
  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };

  const handleRefresh = (e, id, txnIdParam, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(id);
      setRefreshId(txnIdParam);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== txnIdParam),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance,Admin",
        },
      });
    }
  };

  const isNoTransactionSelected = transactionFilterData.length === 0;
  let total = transactionFilterData?.reduce((acc, obj) => {
    return acc + parseInt(obj?.amount);
  }, GlobalConfiguration.lengthCheckZero);

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllBeneTxnAccounts(updatedAccounts);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleTxnApproval = async (id) => {
    setLoading(true);
    if (isMobileResponsive) {
      // Mobile: use loading overlay only
    } else {
      showLoadingToast("Approving transactions");
    }

    if (transactionFilterID.length > GlobalConfiguration.lengthCheckZero) {
      const data = await dispatch(ReimbursementTxnMultiWaitingApproval(id));

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === errorcode.errorFailed) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

              variant: "var(--error)",
              buttonNeeded: false,
              btnProps: {
                enabledBgColor: "var(--primary-bg)",
                enabledTextColor: "var(--text-primary)",
                btnText: "",
                handleFunction: () => {},
                icon: "",
                btnType: "button",
                isDisabled: false,
                hoverOption: "white",
              },
            });
          }, IntervalConfiguration.intervalMedium);
        }
        if (
          data?.payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "AReimbursementTxn",
              },
            });
          }, IntervalConfiguration.intervalMedium);
        } else if (data?.payload?.status === true) {
          const selectedscheduleData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem(
            "selectedReimbursementTxnData",
            JSON.stringify(selectedscheduleData),
          );
          navigate(
            "/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_success",
            {
              replace: true,
            },
          );
        } else if (data?.payload?.response?.data?.status === false) {
          navigate(
            "/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_error",
            {
              replace: true,
            },
          );
        }
      }, IntervalConfiguration.intervalExtraLarge);
    }
  };

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );
    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(
        window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
      );
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      refreshingToastId.current = null;
      setTimeout(() => {
        refreshingToastId.current = UniversalRefreshToast();
      }, IntervalConfiguration.intervalTiny);
    } else if (createTransactionBankRefreshData?.status) {
      if (refreshingToastId.current) {
        toast.dismiss(refreshingToastId.current);
        refreshingToastId.current = null;
      } else {
        toast.dismiss();
      }
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,

          variant: "var(--success)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      if (refreshId) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshId),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      if (refreshingToastId.current) {
        toast.dismiss(refreshingToastId.current);
        refreshingToastId.current = null;
      } else {
        toast.dismiss();
      }
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      if (refreshId) {
        setFailedRefreshId((prev) => [...prev, refreshId]);
      }
    }
    if (createTransactionBankRefreshData) {
      let data = transactionFilterData.map((val) => {
        if (
          val.owner_account_id ===
          createTransactionBankRefreshData?.owner_accounts[
            GlobalConfiguration.lengthCheckZero
          ]?.owner_account_id
        ) {
          return {
            ...val,
            owner_account_balance:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance,
            owner_account_balance_last_fetched_at_in_words:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance_last_fetched_at_in_words,
          };
        }
        return val;
      });

      setTransactionFilterData(data);
      const selectedscheduleData = {
        selectedSendTransactions: data,
        selectedTransactions: transactionFilterID,
      };

      sessionStorage.setItem(
        "selectedReimbursementTxnData",
        JSON.stringify(selectedscheduleData),
      );
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    refreshAnimation,
    refreshId,
    dispatch,
    transactionFilterID,
    transactionFilterData,
  ]);

  return (
    <>
      {showPopup && (
        <ReimbursementDeclinePopup
          allTxnData={AllBeneTxnAccounts}
          handleClose={() => setShowPopup(false)}
          txnId={deniedId}
          updateAllTxn={updateAllAccounts}
          flow="multiApproval"
        />
      )}
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementTxnDetailsPopup
            closePopup={closeBeneTxnDetailModal}
            account_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            TransactionHeader={"Reimbursement transaction details"}
            setTransactionFilterData={setTransactionFilterData}
            setTransactionFilterID={setTransactionFilterID}
          />
        </div>
      )}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container">
          <ApprovalTopNavComponent
            handleBack={() => navigate(-1)}
            topNavCtaBtn1Needed={false}
            topNavHeader={total}
            topNavSubText={"Total amount"}
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",

              isDisabled: isNoTransactionSelected,
              handleFunction: () => handleOpenPopup(transactionFilterID),
              enabledBgColor: "var(--failed)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              iconToBeAlign: "right",
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve",
              isDisabled: isNoTransactionSelected,
              handleFunction: () => handleTxnApproval(transactionFilterID),
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,

              iconToBeAlign: "right",
            }}
            BottomHeader={`Post approval process`}
            BottomSubText={`Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: ICONS?.RELOAD_REFRESH_WHITE,
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: ICONS?.RELOAD_REFRESH_WHITE,
                title: "Refresh reimbursement",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div className="int-txn-mutli-select-data-card">
          {/* <h4>Selected Transaction ({transactionFilterData?.length})</h4> */}
          {transactionFilterData?.length ===
          GlobalConfiguration.lengthCheckZero ? (
            <>
              <div className=" flex flex-col items-center justify-center h-height-full">
                <img
                  src={ICONS?.NO_PENDING_TRANSACTION}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-width-md"}
                />
                <p className="text-text-primary text-center text-font-sm font-normal mt-margin-sm">
                  There are no more transactions that require your <br />
                  approval.
                </p>
                <button
                  className="bg-primary-nav-act flex font-semibold gap-gap-xs items-center justify-center mt-margin-sm px-padding-button-l py-padding-button-s rounded-border-radius-md text-font-sm text-text-primary"
                  onClick={() => navigate(-1)}
                >
                  Go to approval
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="standard-card-alignment gap-gap-md ">
                {transactionFilterData?.map((val, i) => {
                  return (
                    <div
                      className=""
                      key={val?.txn_id || i}
                    >
                      <CardContainer
                        isDisabled={false}
                        isSelected={false}
                        onClickHandler={(e) => {
                          e.stopPropagation();
                        }}
                        isNoHoverRequired={true}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"Amount"}
                            fontWeight={"semibold"}
                            text={val?.amount}
                            textColor={"var(--settled)"}
                            subText={"Amount"}
                            iconComponentArray={
                              val.beneficiary_account_approval_status !==
                              "pending"
                                ? [
                                    ...(val?.confidential_transaction === "Y"
                                      ? [
                                          {
                                            icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                            title: "confidential",
                                            isDisabled: false,
                                          },
                                        ]
                                      : []),
                                  ]
                                : []
                            }
                          />
                          <TextWithIcon
                            type={"Text"}
                            fontWeight={
                              val.beneficiary_account_approval_status ===
                              "pending"
                                ? "var(--font-normal)"
                                : "var(--font-semibold)"
                            }
                            text={val.beneficiary_account_name}
                            textColor={"var(--text-primary)"}
                            subText="Account name"
                          />
                          <div className="relative">
                            <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border px-mobile-padding-l Qmd:px-padding-sm border-primary-bg">
                              <p
                                className={`text-font-sm text-text-primary w-full truncate  font-normal `}
                              >
                                {val.created_on
                                  ? formatDateViewAll(
                                      val.created_on,
                                      false,
                                      false,
                                    )
                                  : "Not given"}
                              </p>
                              <div className="w-full   flex  justify-between items-center ">
                                <p
                                  className={`text-font-xs w-width-md text-text-secondary transform-none  font-normal`}
                                >
                                  Date
                                </p>
                                <div className="z-z-index-overlay absolute right-0 bottom-0.5">
                                  <SecondaryButton
                                    btnText={
                                      val.beneficiary_account_approval_status ===
                                      "pending"
                                        ? "Approve account"
                                        : "Reimbursement details"
                                    }
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      openBeneTxnDetailModal();
                                      setTxnId(val.txn_id);
                                    }}
                                    isDisabled={false}
                                    enabledBgColor={"var(--text-primary)"}
                                    enabledTextColor={"var(--primary-bg)"}
                                    icon={ICONS?.ARROW_RIGHT_WHITE}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <TextWithBank
                            text={val.owner_account_bank_acc_no}
                            type={"AccountNumber"}
                            subText={"Source account"}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                            ifscCode={val?.owner_account_ifsc_code}
                          />

                          <TextWithIcon
                            type="Amount"
                            fontWeight={"semibold"}
                            text={
                              val?.owner_account_balance
                                ? val?.owner_account_balance
                                : "Not available"
                            }
                            subText={"Balance"}
                            textColor={
                              Number(val?.owner_account_balance) >=
                              Number(val?.amount)
                                ? "var(--settled)"
                                : "var(--failed)"
                            }
                            iconComponentArray={[
                              ...(function () {
                                let iconUrl = "";
                                let titleText = "";

                                if (
                                  createTransactionBankRefreshLoading &&
                                  refreshId === val?.txn_id
                                ) {
                                  iconUrl = ICONS?.LOADER_GIF;
                                  titleText = "Balance updating";
                                } else if (
                                  failedRefreshId.includes(val?.txn_id)
                                ) {
                                  iconUrl = ICONS?.ERROR_WITH_ORANGE_CIRCLE;
                                  titleText = "Balance fetch failed";
                                } else if (
                                  !createTransactionBankRefreshLoading &&
                                  refreshId === val?.txn_id &&
                                  val?.owner_account_id === refreshAnimation &&
                                  PrevBalance !== undefined &&
                                  Number(val?.owner_account_balance) !==
                                    Number(PrevBalance)
                                ) {
                                  if (
                                    Number(val?.owner_account_balance) >
                                    Number(PrevBalance)
                                  ) {
                                    iconUrl = ICONS?.ARROW_UP_GREEN_GIF;
                                    titleText = "Balance updated";
                                  } else if (
                                    Number(val?.owner_account_balance) <
                                    Number(PrevBalance)
                                  ) {
                                    iconUrl = ICONS?.ARROW_DOWN_RED_GIF;
                                    titleText = "Balance updated";
                                  }
                                }

                                return iconUrl
                                  ? [
                                      {
                                        icon: iconUrl,
                                        title: titleText,
                                        isDisabled: false,
                                      },
                                    ]
                                  : [];
                              })(),
                              ...(() => {
                                if (checkService)
                                  return [
                                    {
                                      icon: ICONS?.RELOAD_REFRESH_WHITE,
                                      title: "Refresh balance",
                                      isDisabled: !(
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ),
                                      onClick: (e) => {
                                        if (
                                          !createTransactionBankRefreshLoading ||
                                          refreshId !== val?.txn_id
                                        ) {
                                          if (
                                            services?.includes(
                                              "VAccountBalance",
                                            ) ||
                                            services?.includes("Admin")
                                          ) {
                                            handleRefresh(
                                              e,
                                              val?.owner_account_id,
                                              val?.txn_id,
                                              val?.owner_account_balance,
                                            );
                                          } else {
                                            e.stopPropagation();
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  "VAccountBalance,Admin",
                                              },
                                            });
                                          }
                                        } else {
                                          e.stopPropagation();
                                        }
                                      },
                                      bgColor: "var(--primary-nav)",
                                    },
                                  ];
                                return [];
                              })(),
                            ]}
                          />
                          <TextWithIcon
                            text={val?.labels?.join(", ") || "Not assigned"}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                          />
                        </card-body>
                      </CardContainer>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ReimbursementTxnMultiApprovalDetail;
